export default __webpack_public_path__ + "static/media/placeholder_dummy2016-immobilien01-de.c4f8acdd.png";